import { useEffect, useState } from "react";

const navItems = [
  { id: "nav-cases", label: "实锤汇总", href: "#cases" },
  { id: "nav-entries", label: "类型入口", href: "#entries" },
  { id: "nav-timeline", label: "线索时间线", href: "#timeline" },
  { id: "nav-files", label: "材料下载", href: "#files" },
  { id: "nav-discuss", label: "讨论区", href: "#discuss" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50/70 backdrop-blur-sm"
      }`}
    >
      <div className="flex w-full items-center gap-6 px-4 py-3.5 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-bookmark-3-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <h1 className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              海角黑料
            </h1>
            <span className="mt-1 text-[11px] font-normal tracking-wide text-foreground-500">
              实锤证据汇总站
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <label className="flex w-56 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-500 focus-within:border-primary-400 lg:w-64">
            <i className="ri-search-line text-base"></i>
            <input
              type="text"
              placeholder="搜索证据 / 关键词"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </label>
          <button
            type="button"
            className="hidden cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 lg:inline-flex"
          >
            我要投稿
          </button>
          <button
            type="button"
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            登录
          </button>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <label className="mb-3 flex w-full items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-500">
            <i className="ri-search-line text-base"></i>
            <input
              type="text"
              placeholder="搜索证据 / 关键词"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </label>
          <div className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="cursor-pointer border-b border-background-200 py-3 text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
          <div className="mt-4 flex gap-3">
            <button
              type="button"
              className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700"
            >
              我要投稿
            </button>
            <button
              type="button"
              className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              登录
            </button>
          </div>
        </div>
      )}
    </header>
  );
}